<script setup lang="ts">
import type { UmbracoFormField } from 'types/blocks';

const props = defineProps<{
  field: UmbracoFormField;
}>();

const spacing = computed(() => {
  if (props.field.settings.captionTag === 'h2' || props.field.settings.captionTag === 'h3') {
    return 'mt-4 lg:mt-8';
  }

  return 'lg:mt-4';
});
</script>

<template>
  <div :class="spacing">
    <component
      :is="field.settings.captionTag"
      v-if="field.settings.captionTag"
    >
      {{ field.settings.caption || field.caption }}
    </component>

    <p v-if="field.settings.bodyText">
      {{ field.settings.bodyText }}
    </p>
  </div>
</template>
